import React from "react"
import {FieldViewSize} from "../../../../const";
import Votes from "../../../../../model2/voting/votes";
import FieldVoting_View from "../view";
import {ALL_REACTIONS} from "../../../../../model2/reaction/const";
import FieldVoting from "../../voting";
import EmojiSymbolDeprecated from "../../../../../gd-components/icons/common/emoji/emoji-symbol";
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";

// const debug = "FieldVoting_FormElementView"
const debug = false

type State = {
    isHovered           : boolean
    showPopover         : boolean
}

export default class FieldVoting_FormElementView extends React.Component<FieldFormElementViewProps,State> {

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    state : State = {
        isHovered   : false,
        showPopover : false
    }

    get field():FieldVoting {
        return this.props.field as unknown as FieldVoting
    }

    // the value always comes from the model - it is never mirrored in the state, the form owns it
    get votes():Votes {
        return Votes.initFromJson(this.props.field.getViewValue(this.props.model))
    }

    // unlike the editable, editing is NOT gated on the project acl - a form element has no task
    // behind it (a task type template has no projectId at all, so the acl lookup always failed and
    // the control stayed dead). FieldFormElementView has already applied the field access check
    // and passes the result in as `disabled`
    get canEdit():boolean {
        return !this.props.disabled
    }

    get classes():string {

        // min-w-80 -needed in editable like project info

        return Classes("ui5-field-form-editable", "dropdown-form", "flex-row-center-between", "h-36", "min-w-80", this.props.className, {
            "is-hovered"                    : this.state.isHovered,
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
    }

    onClick = () => {

        if (!this.canEdit || this.state.showPopover) return false

        const votes : Votes = this.votes
        votes.toggleVote()

        debug && console.log(debug, "onClick newValue=", votes.toJSON())

        this.props.onChange && this.props.onChange(votes.toJSON())
    }

    onInfoClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        this.setState((prevState:State)=>{
            return {
                showPopover : !prevState.showPopover,
                isHovered   : true
            }
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover : false,
            isHovered   : false
        })
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({isHovered: true})
    }

    onMouseLeave = () => {
        if (this.state.isHovered && !this.state.showPopover) this.setState({isHovered: false})
    }

    render() {

        const field     = this.field
        const isEmpty   = this.votes.isEmpty

        debug && console.log(debug, "render() size=", this.props.size, "isEmpty=", isEmpty, this.state)

        return (
            <div className    = {this.classes}
                 onClick      = {this.onClick}
                 onMouseEnter = {this.onMouseEnter}
                 onMouseLeave = {this.onMouseLeave}>

                {/* a form element is always rendered - the editable can hide an empty value until it
                    is hovered, but here there would be nothing left to click to cast the first vote */}
                {!isEmpty &&
                    <FieldVoting_View field={this.props.field} model={this.props.model} />
                }

                {isEmpty &&
                    <div className="flex-row-left-center">
                        <EmojiSymbolDeprecated symbol={ALL_REACTIONS[field.voteIcon]} className="ui5-black-and-white m-r-8" size="14" />
                        <div className="ui5-txt-no-accent-small">0</div>
                    </div>
                }

                {this.state.showPopover &&
                    <field.components.PopoverMenu field  = {this.props.field}
                                                  model  = {this.props.model}
                                                  parent = {this} />
                }

                {this.state.isHovered &&
                    <div className="buttons flex-no-shrink">
                        {!isEmpty &&
                            <div className="ii5-information ui5-txt-not-important-small" onClick={this.onInfoClick}/>
                        }
                    </div>
                }
            </div>
        )
    }
}
